import React from "react";

import { TBettingTypeGroup } from "@state/stores/offer/event/EventViewStore";

import { BettingType } from ".";

export function BettingTypeGroupBody(props: {
	group: TBettingTypeGroup;
	isFavorite?: boolean;
	isExpanded: boolean;
}) {
	const { isExpanded, group, isFavorite } = props;

	if (!isExpanded) {
		return null;
	}

	return (
		<div className="offer__body offer--additional__body">
			{/* <div className={`match--additional match--${group.abrv}`}> */}
			{group.bettingTypes.map((bt) => (
				<BettingType
					key={bt.id}
					bettingType={bt}
					isFavorite={isFavorite}
				/>
			))}
			{/* </div> */}
		</div>
	);
}
